<template>
  <div
    class="ProductResourceGroup"
    :class="content.resources.length > 4 && 'largeGroup'"
  >
    <h5 class="title">{{ content.title }}</h5>
    <div class="linkBox">
      <div v-for="resource in content.resources" :key="resource._key">
        <SystemRequirements v-if="resource.systemRequirements"
          :text="resource.systemRequirements"
          class="systemRequirements"
        />
        <ProductResourceLink
          :resource="{ ...resource, group: content.slug, product }"
          class="resourceLink"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductResourceLink from './ProductResourceLink.vue'
import SystemRequirements from './SystemRequirements.vue'

export default {
  components: {
    ProductResourceLink,
    SystemRequirements,
  },
  props: {
    content: {
      type: Object,
      default: Object,
    },
    product: {
      type: String,
    },
  },
}
</script>

<style scoped>

.title {
  color: var(--text-color-black);
  font-weight: 600;
  font-size: var(--font-size-5);
}

.linkBox {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.title + .linkBox {
  margin-top: var(--spacing-8);
}

.systemRequirements + .resourceLink {
  margin-left: var(--spacing-1);
}

.resourceLink:focus-visible {
  outline-style: none;
}

@media (--screen-lg) {

  .largeGroup {
    grid-column: 1 / span 2;
  }

  .largeGroup .linkBox {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
